<style scoped>
.bodywrap {
    height: 100vh;
    background-image:url("../assets/img/banner-3.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

}
.container{
    padding-top: 150px;
}
input{
  color: white;
}
.mt450 {
  margin: auto !important;
}
</style>

<template lang='pug'>
  div.bodywrap
   .container.valign-wrapper
      .row.mt450
          .col.s12.m6
              .row
                  .col.s12.m8.push-m2
                      img.responsive-img(src="../assets/inomph_logo.png")
          .col.s12.m6
              .row
                  .col.s12.m10.push-m1
                    form(v-on:submit='login')
                      .input-field
                        label(for="email") Email address
                        input#email(type="text", v-model='email')
                      .input-field
                        label(for="password") Password
                        input#password(type="password", v-model='password')
                      button.btn.waves-effect.waves-light(type='submit') Log in
</template>
<script>
export default {
  meta: {
    title: 'Log-in - Inom.ph supplier'
  },
  data () {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    login (e) {
      e.preventDefault()
      this.$store.dispatch('auth/localLogin', {
        email: this.email,
        password: this.password,
        scope: 'admin'
      })
        .then(user => {
          if (user.type !== 'admin') {
            this.$store.dispatch('auth/clear')
            throw new Error('Invalid account')
          }

          this.$router.replace('home')
        }).catch(err => {
          this.$log.error(err)
          this.$snackbar.error(err.message)
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page-login.vue